(function () {
    'use strict';

    angular
        .module('app')
        .controller('editCompanyController',
        [
            '$routeParams',
            '$timeout',
            'accountsService',
            'companyService',
            'pagerService',
            'clientService',
            '_',
            '$uibModal',
            '$filter',
            '$location',
            'permissionsService',
            'thirdPartyCredentialsService',
            editCompanyController
        ]);


    function editCompanyController($routeParams,
        $timeout,
        accountsService,
        companyService,
        pagerService,
        clientService,
        _,
        $uibModal,
        $filter,
        $location,
        permissionsService,
        thirdPartyCredentialsService) {
        /* jshint validthis:true */
        var vm = this;
        vm.model = {}
        vm.companyId = $routeParams.companyId;
        vm.company = {};
        vm.users = {};
        vm.usersFiltered = {};
        vm.userFilterApplied = false;
        vm.applyUserFilter = applyUserFilter;
        vm.clearUserFilter = clearUserFilter;
        vm.emailDomains = {};
        vm.originalEmailDomains = 0;
        vm.currentEmailDomains = 0;
        vm.removedEmailDomains = [];
        vm.createApiCredentialModel = {};
        vm.activeTab = 0;
        vm.newApiCreds = {
            eId: "",
            thirdPartyUse: true,
            name: "",
            password: ""
        }
        vm.createApiFailed = {
            isFailed: false,
            message: ""
        };
        vm.userPasswordShowSecretFailed = {
            isFailed: false,
            message: ""
        };

        vm.apiCredList = [];
        vm.editViewApiCreds = {};

        vm.allowedIpAddresses = {};
        vm.allowedIpAddressesPaged = [];
        vm.originalAllowedIpAddresses = 0;
        vm.currentAllowedIpAddresses = 0;
        vm.removedAllowedIpAddresses = [];

        
        vm.originalEnvironments = 0;
        vm.currentEnvironments = 0;
        vm.displayedEnvironments = [];
        vm.environmentPageSize = 10;
        vm.environmentPager = {};
        vm.setEnvironmentPage = setEnvironmentPage;
        
        vm.showUpdateCredentialModal = showUpdateCredentialModal;
        vm.showSelectWorkbooksOrganisationModal = showSelectWorkbooksOrganisationModal;
        vm.showAddThirdPartyCredentialsModal = showAddThirdPartyCredentialsModal;
        vm.removeThirdPartyCredentials = removeThirdPartyCredentials;
        vm.editThirdPartyCredentials = editThirdPartyCredentials;
        vm.showCrmCredentialsTab = showCrmCredentialsTab;

        vm.hiddenProducts = [];
        vm.hideProduct = hideProduct;
        vm.showProduct = showProduct;

        vm.environments = [];
        vm.environment = {
            environment: '',
            displayName: '',
            errors: [],
            working: false,
            success: false,
            isValid: function(isCreate) {

                if (isCreate) {
                    if (vm.environment.length > 0)
                        return false;

                    if (!vm.environment.displayName.length > 0)
                        return false;

                    if (!(vm.environment.ssoClientType.id === 9 || vm.environment.ssoClientType.id === 4 || vm.environment.ssoClientType.id === 14))
                        return false;

                    return true;
                } else
                    return !vm.environment.environment || !vm.environment.displayName;
            }
        };

        vm.account = {
            user: {
                firstName: '',
                lastName: '',
                password: '',
                email: '',
                isAdmin: false,
                ssoClientUsers: [],
                company: {
                    id: $routeParams.companyId
                },
            },
            working: false,
            success: false,
            errors: []
        };

        vm.ssoClientTypes = [];
        vm.waiting = false;
        vm.deactivateUser = deactivateUser;
        vm.userPager = {};
        vm.setUserPage = setUserPage;
        vm.userPageSize = 10;
        vm.sendActivateEmail = sendActivateEmail;

        vm.emailPager = {};
        vm.setEmailPage = setEmailPage;
        vm.emailPageSize = 10;

        vm.ipAddressPager = {};
        vm.setIpAddressPage = setIpAddressPage;
        vm.ipAddressPageSize = 10;

        vm.clients = [];
        vm.isAdminClass = isAdminClass;

        vm.emailDomain = {};
        vm.emailDomain.domain = '';
        vm.emailDomain.errors = [];
        vm.emailDomain.checking = false;
        vm.emailDomain.regex = '\\b((?=[a-z0-9-]{1,63}\\.)[a-z0-9]+(-[a-z0-9]+)*\\.)+[a-z]{2,63}\\b';

        vm.emailDomain.add = function() {

            companyService.addEmailDomain(vm.company.id, vm.emailDomain.domain).then(function(response) {


                if (response.data.length > 0)
                    vm.emailDomain.errors = response.data.errors;

                if (!vm.emailDomain.errors || vm.emailDomain.errors.length === 0) {
                    vm.emailDomains.push({ id: response.data.id, domain: vm.emailDomain.domain });
                    vm.emailDomain.domain = '';

                }


            });
        };

        vm.emailDomain.remove = function (index, emailDomain) {

            companyService.removeEmailDomain(vm.company.id, emailDomain).then(function(response) {
                vm.emailDomains.splice(index, 1);
            });

        };

        vm.environment.add = function () {
            vm.environment.errors = [];

            companyService.addEnvironment(vm.company.id, vm.environment.displayName, vm.environment.environment, vm.environment.ssoClientType.id).then(function (response) {

                if (response.data.errors)
                    if (response.data.errors.length > 0)
                        vm.environment.errors = response.data.errors;

                if (!vm.environment.errors || vm.environment.errors.length === 0) {
                    vm.environments.push({
                        id: response.data.id,
                        displayName: vm.environment.displayName,
                        environment: vm.environment.environment,
                        ssoClient: vm.environment.ssoClientType
                    });

                    vm.environment.displayName = '';
                    vm.environment.environment = '';

                }


            });
        };

        vm.environment.create = function () {
            vm.environment.working = true;
            vm.environment.sucess = false;
            companyService.createEnvironment(vm.company.id, vm.environment.ssoClientType.id, vm.environment.displayName).then(
                function (environment) {

                    if (environment.success) {
                        vm.environments.push({
                            id: environment.id,
                            displayName: environment.displayName,
                            environment: environment.environment,
                            ssoClient: environment.ssoClient
                        });

                        vm.environment.displayName = '';
                        vm.environment.environment = '';



                        vm.environment.sucess = true;
                    } else {
                        vm.environment.errors.push(environment.error);
                        vm.environment.sucess = false;

                    }
                    vm.environment.working = false;

                },
                function (error) {
                    console.dir(error);
                });


        };
        vm.apiPasswordUpdated = false;
        vm.ShowSecretPassword = "";
        vm.newApiCredsRulespassed = null;
        vm.editApiCredsRulespassed = null;
        vm.createApiCredentials = function (environment) {
            vm.createApiFailed = {
                isFailed: false,
                message: ""
            };
            vm.newApiCreds = {
                eId: "",
                enviroment: environment,
                thirdPartyUse: false,
                password: "",
                nid: "",
                clientId: "",
                name: "",
                clientSecret: "",
                companyId: vm.model.companyId
            };
            $("#createCompanyClientCred").modal("show");
        }
        vm.createApiCredBtn = function () {

            if (vm.newApiCreds.name === "") {
                vm.createApiFailed.isFailed = true;
                vm.createApiFailed.message = "Name Not set";
                return;
            }

            if (vm.newApiCredsRulespassed() !== 5) {
                vm.createApiFailed.isFailed = true;
                vm.createApiFailed.message = "Password strength not met";
                return;
            }

            permissionsService.CreateCompanyClient(vm.newApiCreds.companyId, vm.newApiCreds.enviroment.id, vm.newApiCreds.name, vm.newApiCreds.password).then(
                function (response) {
                    getCompanyApiClients();
                    $("#createCompanyClientCred").modal("hide");
                }, function (responce) {
                    vm.createApiFailed.isFailed = true;
                    vm.createApiFailed.message = "Could Not Create the requested Api credentials. please contact support for assistance.";
                });
        }
        vm.ViewEditApiCredentials = function (apiCred) {
            vm.createApiFailed = {
                isFailed: false,
                message: ""
            };
            vm.apiPasswordUpdated = false;
            vm.editViewApiCreds = apiCred;
            $("#editViewCompanyClientCred").modal("show");
        }
        vm.RemoveApiCredentials = function (apiCred) {
            $("#editViewCompanyClientCred").modal("hide");
            vm.createApiFailed = {
                isFailed: false,
                message: ""
            };
            vm.editViewApiCreds = apiCred;
            $("#removeCompanyClientCred").modal("show");
        }
        vm.ConfrimRemoveApiCredentials = function () {
            $("#removeCompanyClientCred").modal("hide");
            permissionsService.DeleteCompanyClient(vm.editViewApiCreds.id).then(
                function(responce) {
                    getCompanyApiClients();
                });
            vm.editViewApiCreds = {};
        }
        vm.UpdateClientPassword = function () {

            vm.apiPasswordUpdated = false;
            if (vm.editApiCredsRulespassed() !== 5) {
                vm.createApiFailed = {
                    isFailed: true,
                    message: "Password strength not met"
                };
                return;
            }
           
            permissionsService.UpdateClientPassword(vm.editViewApiCreds.id, vm.editViewApiCreds.password).then(
                function() {
                    vm.apiPasswordUpdated = true;
                    setTimeout(function() {
                            vm.apiPasswordUpdated = false;
                        },
                        5000);
                });
        }
        
        vm.ShowSecret = function() {
            vm.ShowSecretPassword = "";
            vm.userPasswordShowSecretFailed = {
                isFailed: false,
                message: ""
            };
            $('#userPasswordShowSecret').modal("show");
        }

        vm.ConfrimShowSecret = function() {

            if (vm.ShowSecretPassword === "") {
                vm.userPasswordShowSecretFailed = {
                    isFailed: true,
                    message: "Please enter you SSO password"
                };
                return;
            }

            permissionsService.ShowClientSecret(vm.model.companyId, vm.ShowSecretPassword).then(
                function (responce) {
                    vm.editViewApiCreds.clientSecret = responce;
                    $("#clientSecret").attr("type", "text");
                    $('#userPasswordShowSecret').modal("hide");
                },
                function(responce) {
                    vm.userPasswordShowSecretFailed = {
                        isFailed: true,
                        message: "Invalid password or user permissions"
                    };
                });

        }

        vm.ipAddress = {};
        vm.ipAddress.ipAddress = '';
        vm.ipAddress.errors = [];
        vm.ipAddress.checking = false;

        vm.ipAddress.add = function() {

            companyService.addIpAddress(vm.company.id, vm.ipAddress.ipAddress).then(function(response) {


                if (response.data.length > 0)
                    vm.ipAddress.errors = response.data.errors;

                if (!vm.ipAddress.errors || vm.ipAddress.errors.length === 0) {
                    vm.allowedIpAddresses.push({ id: response.data.id, ipAddress: vm.ipAddress.ipAddress });
                    vm.ipAddress.ipAddress = '';

                }


            });
        };

        vm.ipAddress.remove = function (index, ipAddress) {

            companyService.removeIpAddress(vm.company.id, ipAddress).then(function (response) {
                vm.allowedIpAddressesPaged.splice(index, 1);
            });

        };

        vm.emailRegex = '[aA-zZ0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[aA-zZ0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[aA-zZ0-9](?:[aA-zZ0-9-]*[aA-zZ0-9])?.)+[aA-zZ0-9](?:[aA-zZ0-9-]*[aA-zZ0-9])?';

        vm.saveForm = saveForm;

        vm.getCompany = getCompany;

        vm.isAccountClientEnabled = isAccountClientEnabled;

        vm.setAccountClient = setAccountClient;
        vm.setAllAccountClient = setAllAccountClient;
        vm.unsetAllAccountClient = unsetAllAccountClient;

        vm.adduserValid = adduserValid;

        vm.addAccount = addAccount;

        vm.resetCreateUser = resetCreateUser;

        vm.removeIpAddress = removeIpAddress;

        vm.impersonate = impersonate;

        getCompany();


        vm.disableImpersonation = function() {

            companyService.disableImpersonation(vm.company.id).then(function(response) {
                vm.company.allowImpersonation = false;
            });
        };
        vm.deactivate = function() {

            companyService.deactivateCompany(vm.company.id).then(function(response) {
                vm.company.deactivated = true;
            });
        };
        vm.reactivate = function() {

            companyService.reactivateCompany(vm.company.id).then(function(response) {
                vm.company.deactivated = false;
            });
        };

        function activate() {

            accountsService.getAuthenticatedAccount().then(function (response) {
                    vm.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                    vm.model.isPartnerAdmin = (response.accountType === AccountType.Partner || response.accountType === AccountType.PartnerSuperAdmin) && vm.company.partnerCode === response.partnerCode;

                    

                    
                    vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                    vm.model.isCompanyAdmin = response.accountType === AccountType.Company && vm.companyId === response.companyId;
                    vm.model.authenticatedAccountId = response.accountId;
                    vm.model.ssoClientUsers = response.ssoClientUsers;
                    
                    vm.model.companyId = response.companyId;

                    vm.model.authenticatedAccountRole = response.accountType;
                    vm.model.isImpersonating = response.isImpersonating;

            });
        }

        function getCompany() {
            companyService.getCompanyById(vm.companyId)
                .then(function (response) {
                    processCompany(response);
                    getCompanyApiClients();
                    getCompanyThirdPartyCredentials();
                });
        }

        function getCompanyApiClients() {
            permissionsService.GetAllClientsforCompany(vm.company.id).then(function (clientResponse) {
                vm.apiCredList = clientResponse;
            });
        }

        function getCompanyThirdPartyCredentials() {
            thirdPartyCredentialsService.getAll(vm.company.id).then(function(credentials) {
                vm.thirdPartyCredentials = credentials;

                vm.thirdPartyCredentialsRequireAttention = credentials.some(function(c) {
                    return !c.valid;
                });
            });
        }

        function setUserPage(page) {
            // get pager object from service
            vm.userPager = pagerService.GetPager(vm.usersFiltered.length, page, vm.userPageSize);

            // get current page of items
            vm.users = vm.usersFiltered.slice(vm.userPager.startIndex, vm.userPager.endIndex);
        }

        function setEnvironmentPage(page) {
            if (page < 1 || page > vm.environmentPager.totalPages) {
                return;
            }

            // get pager object from service
            vm.environmentPager = pagerService.GetPager(vm.environments.length, page, vm.environmentPageSize);

            // get current page of items
            vm.displayedEnvironments = vm.environments.slice(vm.environmentPager.startIndex, vm.environmentPager.endIndex);
        }


        function setIpAddressPage(page) {
            if (page < 1 || page > vm.ipAddressPager.totalPages) {
                return;
            }

            // get pager object from service
            vm.ipAddressPager = pagerService.GetPager(vm.company.allowedIpAddresses.length, page, vm.ipAddressPageSize);

            vm.allowedIpAddresses = vm.company.allowedIpAddresses.slice();

            // get current page of items
            vm.allowedIpAddressesPaged = vm.company.allowedIpAddresses.slice();            
            vm.allowedIpAddressesPaged = vm.allowedIpAddressesPaged.slice(vm.ipAddressPager.startIndex, vm.ipAddressPager.endIndex);
        }

        function setEmailPage(page) {
            if (page < 1 || page > vm.emailPager.totalPages) {
                return;
            }

            // get pager object from service
            vm.emailPager = pagerService.GetPager(vm.company.emailDomains.length, page, vm.emailPageSize);

            // get current page of items
            vm.emailDomains = vm.company.emailDomains.slice(vm.emailPager.startIndex, vm.emailPager.endIndex);
        }
        
        function removeIpAddress(ipAddressId) {
            vm.company.allowedIpAddresses = _.reject(vm.company.allowedIpAddresses, function (ipAddress) {
                if (ipAddress.id === ipAddressId) {
                    vm.removedAllowedIpAddresses.push(ipAddressId);
                    return true;
                }

                return false;
            });
            vm.setIpAddressPage(1);
            vm.currentAllowedIpAddresses--;
        }
       
        function saveForm() {
            vm.waiting = true;
            vm.model.complete = false;
            vm.model.success = false;

            companyService.saveCompanyDetails(vm.company.id, vm.company.name, vm.company.dynamicsId, vm.company.workbooksOrganisationId, vm.company.workbooksOrganisationName, vm.company.partnerCode).then(
                function(response) {
                    vm.waiting = false;
                    vm.model.complete = true;
                    vm.model.success = true;
                },
                function() {
                    vm.waiting = false;
                    vm.model.complete = true;
                    vm.model.success = false;
                });
        }

        function deactivateUser(userId) {

            // find the user
            var user = _.findWhere(vm.company.users, { id: userId });

            if (user !== null && user !== void (0)) {
                vm.waiting = true;
                accountsService.deactivate(user.id).then(function () {
                        user.activated = false;
                        vm.waiting = false;
                    },
                    function () {
                        vm.waiting = false;
                    });

            }
        }

        function sendActivateEmail(userId) {

            // find the user
            var user = _.findWhere(vm.company.users, { id: userId });

            if (user !== null && user !== void (0)) {
                vm.waiting = true;
                accountsService.sendActivationEmail(user.id)
                    .then(function () {
                        user.activated = false;
                        vm.waiting = false;
                    },
                    function () {
                        vm.waiting = false;
                    });

            }
        }

        function impersonate(userId) {
            $location.url('/impersonate/' + userId);
        }

        function canCreateUser(endPointsEnum) {
            return ((endPointsEnum & ssoEndPoints.CreateAccount) === ssoEndPoints.CreateAccount);
        }

        function isAccountClientEnabled(environment) {
            var accountClient = _.find(vm.account.user.ssoClientUsers,
                function (client) {
                    return client.type === environment.ssoClient.type && client.uniqueId === environment.environment;
                });

            return accountClient.allowAccess ? 'fa-check-circle' : 'fa-times-circle';
        }

        function setAccountClient(environment) {
            var accountClient = _.find(vm.account.user.ssoClientUsers, function (client) {
                    return client.type === environment.ssoClient.type && client.uniqueId === environment.environment;
                });

            accountClient.allowAccess = !accountClient.allowAccess;
        }

        function setAllAccountClient() {
            vm.account.user.ssoClientUsers.forEach(function (client) {
            
                client.allowAccess = true;
            });
        }

        function unsetAllAccountClient() {
            vm.account.user.ssoClientUsers.forEach(function (client) {

                client.allowAccess = false;
            });
        }

        function adduserValid() {
            var passwordPass = (!(vm.account.user.password === void (0)) && vm.account.user.password.length > 5);

            var emailPass = (!(vm.account.user.email === void (0)) && vm.account.user.email.length > 4);

            var jobTitle = (!(vm.account.user.jobTitle === void(0)) && vm.account.user.jobTitle.length > 0);

            var firstNamePass = (!(vm.account.user.firstName === void (0)) && vm.account.user.firstName.length > 0);

            var lastNamePass = (!(vm.account.user.lastName === void (0)) && vm.account.user.lastName.length > 0);

            return passwordPass && emailPass && firstNamePass && lastNamePass && jobTitle;

        }

        function addAccount() {

            vm.account.waiting = true;
            // check the domain is correct
            companyService.checkDomain(vm.account.user.email)
                .then(function (response) {

                    vm.account.errors = response;

                    vm.account.waiting = false;

                        if (!vm.account.errors || vm.account.errors.length === 0) {
                            vm.account.waiting = true;
                            accountsService.createAccount(vm.account.user)
                                .then(function(response) {
                                        // Account Created reset the form and inform the user
                                        vm.account.waiting = false;
                                        vm.createAccountForm.$setPristine(true);

                                        vm.account.waiting = false;
                                        vm.account.errors = [];

                                        angular.forEach(response.errors,
                                            function(value) {
                                                this.push(value.message);
                                            },
                                            vm.account.errors);

                                        vm.account.success = true;
                                        vm.accountCreationStep2 = false;
                                        vm.account.user.ssoClientUsers = [];
                                        
                                        vm.getCompany();
                                    },
                                    function(response) {
                                        vm.account.waiting = false;
                                        vm.account.errors = [];


                                        angular.forEach(response.errors,
                                            function(value) {
                                                this.push(value.message);
                                            },
                                            vm.account.errors);
                                        vm.accountCreationStep2 = false;
                                    });
                        } else {
                            vm.accountCreationStep2 = false;
                            vm.account.success = false;
                            vm.account.waiting = false;
                        }
                    },
                function (response) {
                    vm.account.waiting = false;
                    vm.account.errors = response.errors;
                    vm.accountCreationStep2 = false;
                });

        }

        function resetCreateUser() {
            vm.account.user.firstName = '';
            vm.account.user.lastName = '';
            vm.account.user.password = '';
            vm.account.user.email = '';
            vm.account.user.isAdmin = false;
            vm.account.user.jobTitle = '';
            vm.account.working = false;
            vm.account.success = false;
            vm.account.errors = [];

            vm.accountCreationStep2 = false;

            angular.forEach(vm.account.user.ssoClientUsers,
                function (value) {
                    value.allowAccess = true;
                });


        }

        function isAdminClass() {

            if (!vm.account.user.isAdmin) {
                return 'fa-times-circle';
            } else {
                return 'fa-check-circle';
            }
        }

        function processCompany(company) {

            vm.clients = [];
            vm.company = company;
            activate();
            vm.usersFiltered = company.users.map(function (item) {
                switch (item.type) {
                case 0:
                    item.friendlyType = "User";
                    break;
                case 1:
                    item.friendlyType = "Company Admin";
                    break;
                case 2:
                    item.friendlyType = "Partner Admin";
                    break;
                case 3:
                    item.friendlyType = "Partner Super Admin";
                    break;
                case 4:
                    item.friendlyType = "Admin";
                    break;
                case 5:
                    item.friendlyType = "Super Admin";
                    break;
                }

                return item;
            });


            vm.setUserPage(1);
            vm.setEmailPage(1);
            
            
            vm.setIpAddressPage(1);
            if (vm.company.emailDomains) {
                vm.originalEmailDomains = vm.company.emailDomains.length;
                vm.currentEmailDomains = vm.company.emailDomains.length;
            }

            if (vm.company.environments) {
                vm.environments = vm.company.environments;
                vm.displayedEnvironments = vm.company.environments;
                vm.originalEnvironments = vm.company.environments.length;
                vm.currentEnvironments = vm.company.environments.length;
            }

            vm.setEnvironmentPage(1);

            if (vm.company.hiddenProducts) {
                vm.originalHiddenProducts = vm.company.hiddenProducts.length;
                vm.currentHiddenProducts = vm.company.hiddenProducts.length;
            }

            if (vm.company.allowedIpAddresses) {
                vm.originalAllowedIpAddresses = vm.company.allowedIpAddresses.length;
                vm.currentAllowedIpAddresses = vm.company.allowedIpAddresses.length;
            }

            
            


            clientService.getClients().then(function (response) {

                    vm.ssoClientTypes = _.filter(response, function(ssoClient) {
                            return ssoClient.type !== 7;
                    });


                    angular.forEach(vm.ssoClientTypes,
                        function(client) {

                            var unrestrictedClient = _.findWhere(client.clientDetails, { restricted: false });

                            if (_.isUndefined(unrestrictedClient) ||
                                !canCreateUser(unrestrictedClient.availableEndPoints))
                                return;

                            if (client.type !== 7) {

                                var enviroments = _.filter(vm.company.environments,
                                    function(enviroment) {
                                        return enviroment.ssoClient.type === client.type;
                                    });

                                if (enviroments.length === 0) {
                                    return;
                                }

                                this.push({
                                    id: client.id,
                                    type: client.type,
                                    name: client.name,
                                    shortName: client.shortName,
                                    formattedName: client.formattedName,
                                    visible: false,
                                    available: enviroments
                                });

                                angular.forEach(enviroments,
                                    function(enviroment) {
                                        vm.account.user.ssoClientUsers.push({
                                            ssoClientId: client.id,
                                            type: client.type,
                                            uniqueId: enviroment.environment,
                                            displayName: enviroment.displayName,
                                            endPointsEnum: unrestrictedClient.availableEndPoints,
                                            allowAccess: true

                                        });
                                    });

                            }

                        },
                        vm.clients);
                vm.hiddenProducts = [];
                    angular.forEach(vm.ssoClientTypes,
                        function(client) {

                            var hiddenId = null;

                            if (client.type !== 7 && !client.isHidden) {

                                var hiddenProduct = _.find(vm.company.hiddenProducts,
                                    function(item) {
                                        return item.ssoClient.type === client.type;
                                    });

                                if (!_.isUndefined(hiddenProduct)) {
                                    hiddenId = hiddenProduct.id;
                                }

                                vm.hiddenProducts.push({
                                    id: hiddenId,
                                    ssoClientId: client.id,
                                    type: client.type,
                                    name: client.name,
                                    shortName: client.shortName,
                                    formattedName: client.formattedName
                                });

                            }
                        }
                        );


                });
        }

        function applyUserFilter() {

            if (vm.userFilter === '') {
                vm.usersFiltered = vm.company.users;
                clearUserFilter();
                return;
            }
            //company.users
            vm.usersFiltered = _.filter(vm.company.users, function (user) {
                var regex = new RegExp(vm.userFilter, 'i');

                var match = user.email.match(regex);
                if (match != null) {
                    return true;
                }

                match = user.firstName.match(regex);
                if (match != null) {
                    return true;
                }

                match = user.lastName.match(regex);
                if (match != null) {
                    return true;
                }

                if (vm.userFilter.indexOf(' ') !== -1) {
                    var firstNameRegex = new RegExp(vm.userFilter.split(' ')[0], 'i');
                    var lastNameRegex = new RegExp(vm.userFilter.split(' ')[1], 'i');

                    if (user.firstName.match(firstNameRegex) != null && user.lastName.match(lastNameRegex) != null) {
                        return true;
                    }
                }

                return false;
            });

            vm.userFilterApplied = true;
            vm.setUserPage(1);
        }

        function clearUserFilter() {
            vm.usersFiltered = vm.company.users;
            vm.userFilterApplied = false;
            vm.userFilter = '';
            vm.setUserPage(1);

        }

        function showProduct(clientId) {
            companyService.showProduct(vm.company.id, clientId).then(function(response) {
                var hiddenProduct = _.find(vm.hiddenProducts,
                    function (item) {
                        return item.type === response.ssoClient.type;
                    });

                hiddenProduct.id = null;
            });
        }

        function hideProduct(clientId) {
            companyService.hideProduct(vm.company.id, clientId).then(function(response) {
                var hiddenProduct = _.find(vm.hiddenProducts,
                    function (item) {
                        return item.type === response.ssoClient.type;
                    });

                hiddenProduct.id = response.id;
            });
        }

        function showUpdateCredentialModal(environment) {
            $uibModal.open({
                templateUrl: 'assets/templates/modals/update_integration_credentials.html',
                controller: 'updateIntegrationCredentialsController',
                size: 'lg',
                resolve: {
                    environment: function () {
                        return environment;
                    }
                }
            });
        };

        function showSelectWorkbooksOrganisationModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/modals/select_workbooks_organisation.html',
                controller: 'selectWorkbooksOrganisationController',
                size: 'lg'
            });

            modalInstance.result.then(function (response) {
                vm.company.workbooksOrganisationId = response.id;
                vm.company.workbooksOrganisationName = response.name;
            },function() {

            });
        };

        function showAddThirdPartyCredentialsModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/modals/third_party_credentials.html',
                controller: 'thirdPartyCredentialsController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  args: {
                        isCreate: true,
                        companyId: vm.company.id
                  }
                }
            });

            modalInstance.result.then(function (response) {
                getCompanyThirdPartyCredentials();
                showThirdPartyCredentialsSavedMessage();
            }, function () { });
        }

        function editThirdPartyCredentials(credentials) {
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/modals/third_party_credentials.html',
                controller: 'thirdPartyCredentialsController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    args: {
                        isCreate: false,
                        credentials: credentials,
                        companyId: vm.company.id
                    }
                }
            });

            modalInstance.result.then(function (response) {
                getCompanyThirdPartyCredentials();
                showThirdPartyCredentialsSavedMessage();
            }, function() {});
        }

        function showThirdPartyCredentialsSavedMessage() {
            vm.showThirdPartyCredentialsSavedMessage = true;
            $timeout(function () {
                vm.showThirdPartyCredentialsSavedMessage = false;
            }, 2000);
        }

        function removeThirdPartyCredentials(credentials) {
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/modals/third_party_credentials_removal_confirmation.html',
                controller: 'thirdPartyCredentialsRemovalConfirmationController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    args: {
                        credentials: credentials
                    }
                }
            });

            modalInstance.result.then(function (response) {
                thirdPartyCredentialsService.delete(credentials.credentialsId).then(function () {
                    getCompanyThirdPartyCredentials();

                    vm.showThirdPartyCredentialsDeletedMessage = true;
                    $timeout(function () {
                        vm.showThirdPartyCredentialsDeletedMessage = false;
                    }, 2000);
                });
            }, function () { });
        }

        function showCrmCredentialsTab() {
            vm.activeTab = 6;
        }
    }
})();
